import type { RouteObject } from 'react-router';
import { Navigate } from 'react-router';

import { BASE } from 'common/src/routes/BaseRoutes';
import { Products } from 'common/src/types/enums/Products.enum';

import AdministrationRoutes from './AdministrationRoutes';
import AlertsRoute from './AlertsRoute';
import BillAutomationRoutes from './BillAutomationRoutes';
import CostRoutes from './CostRoutes';
import CustomDashboardRoutes from './CustomDashboardRoutes';
import EvChargingRoutes from './EvChargingRoutes';
import ReportRoutes from './ReportRoutes';
import SmartMetersRoutes from './SmartMetersRoutes';
import SummaryRoutes from './SummaryRoutes';
import SupportRoutes from './SupportRoutes';
import SystemAdministrationRoutes from './SystemAdministrationRoutes';
import UsageRoutes from './UsageRoutes';
import UserSettingsRoute from './UserSettingsRoute';

import IntervalDataElectricRoutes from './intervalData/ElectricRoutes';
import NaturalGasRoutes from './intervalData/NaturalGasRoutes';
import PortfolioRoutes from './intervalData/PortfolioRoutes';
import WaterRoutes from './intervalData/WaterRoutes';

export default function ProductRoutes(): RouteObject[] {
  const routes: RouteObject[] = [
    AdministrationRoutes,
    AlertsRoute,
    CustomDashboardRoutes,
    SupportRoutes,
    SystemAdministrationRoutes,
    UserSettingsRoute,
  ];

  if (import.meta.env.VITE_PRODUCT_ID === Products.intervals) {
    routes.push(
      {
        path: BASE.ROOT,
        element: <Navigate to={BASE.INTERVAL_DATA_PORTFOLIO} replace />,
      },
      IntervalDataElectricRoutes,
      NaturalGasRoutes,
      PortfolioRoutes,
      WaterRoutes,
    );
  } else {
    routes.push(
      { path: BASE.ROOT, element: <Navigate to={BASE.SUMMARY} replace /> },
      BillAutomationRoutes,
      CostRoutes,
      EvChargingRoutes,
      ReportRoutes,
      UsageRoutes,
      SummaryRoutes,
      SmartMetersRoutes,
    );
  }

  return routes;
}
